import 'core-js';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import TDesign from 'tdesign-vue-next';
import 'tdesign-vue-next/es/style/index.css';
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
// import './assets/font/font.css'
import store from './store'; // 引入store/index.ts 文件
import './assets/css/index.scss'

const app = createApp(App);

app.use(TDesign);
app.use(router);
app.use(PerfectScrollbar);
app.use(store);

app.mount('#app');

// createApp(App).use(router).mount('#app')
